/* eslint-disable max-len */
import { Flex } from '@rebass/grid';
import React from 'react';
import styled from 'styled-components';
import { MarketingBubbles } from '../../components/account-setup/svg/MarketingBubbles';

const MarketingBubblesGraphic = styled.div`
  width: 317px;
  height: 481px;
  position: absolute;
  left: 90px;
  z-index: 1;

  svg {
    width: 317px;
    height: 481px;
  }

  @media (max-width: 1280px) {
    left: 40px;
  }
`;

const BubbleText = styled.div`
  font-size: 19px;
  font-weight: bold;
  color: white;
  text-align: center;
  line-height: 25px;
`;

const BubbleTextBlack = styled(BubbleText)`
  color: black;
`;

const BubbleContent = styled(Flex)`
  align-items: center;
  justify-content: center;
  position: absolute;
`;

const BubbleOneContent = styled(BubbleContent)`
  transform: translate(46px, 77px);
  width: 173px;
  height: 78px;
`;

const BubbleTwoContent = styled(BubbleContent)`
  transform: translate(169px, 227px);
  width: 140px;
  height: 78px;
`;

const BubbleThreeContent = styled(BubbleContent)`
  transform: translate(42px, 365px);
  width: 154px;
  height: 78px;
`;

const MarketingBubblesEquation = () => {
  return (
    <MarketingBubblesGraphic>
      <BubbleOneContent>
        <BubbleText>AmTrav&apos;s One Connected Platform</BubbleText>
      </BubbleOneContent>
      <BubbleTwoContent>
        <BubbleText>24/7 Help When You Need It</BubbleText>
      </BubbleTwoContent>
      <BubbleThreeContent>
        <BubbleTextBlack>Happy &amp; Productive Travelers</BubbleTextBlack>
      </BubbleThreeContent>
      <MarketingBubbles />
    </MarketingBubblesGraphic>
  );
};

export default MarketingBubblesEquation;
